import { darken } from "@mui/material";
import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ palette }) => ({
    button_active: {
        color: "white",
        "&.MuiIconButton-colorPrimary:not(.Mui-disabled)": {
            backgroundColor: palette.primary.main,
            "&:hover": {
                backgroundColor: palette.primary.dark,
            },
        },
        "&.MuiIconButton-colorSuccess:not(.Mui-disabled)": {
            backgroundColor: palette.success.main,
            "&:hover": {
                backgroundColor: palette.success.dark,
            },
        },
        "&.MuiIconButton-colorSecondary:not(.Mui-disabled)": {
            backgroundColor: palette.secondary.main,
            "&:hover": {
                backgroundColor: palette.secondary.dark,
            },
        },
        "&.MuiIconButton-colorPaper:not(.Mui-disabled)": {
            backgroundColor: palette.paper.contrastText,
            "&:hover": {
                backgroundColor: darken(palette.paper.contrastText, 0.2),
            },
        },
        "&.MuiIconButton-colorWhite:not(.Mui-disabled)": {
            backgroundColor: palette.white.main,
            color: palette.white.contrastText,
            "&:hover": {
                backgroundColor: "#f2f2f2",
            },
        },
    },
}));
//# sourceMappingURL=ui_icon_button.css.js.map